import { encryptData } from "../Encrypt/Encrypt";
import api from "./api";

// ============================================================
// API BASE URL
// ============================================================

// Production URL
export const URL = "https://npsmanagement.thedestinysolutions.com";
 export const IMAGE_URL = "https://npsmanagement.thedestinysolutions.com";

// Local Development URL
  //  export const URL = "http://192.168.29.45:83";
  //  export const IMAGE_URL = "http://192.168.29.45:83";

// ============================================================
// CUSTOMER REVIEW
// ============================================================

// Get all client
export const getClient = () => {
  return api.post(`${URL}/api/CustomerReview/GetAllCustomerReview`);
};

// ============================================================
// FAQ
// ============================================================

// Get all FAQs
export const getFAQs = () => {
  return api.post(`${URL}/api/FandQMaster/GetAllFandQMaster`);
};

// ============================================================
// CHATGPT CATEGORY
// ============================================================

// Get all Category
export const getCategory = () => {
  return api.post(`${URL}/api/ChatGpt/GetAllCategory`);
};

// Get all SubCategory
export const getSubCategory = () => {
  return api.post(`${URL}/api/ChatGpt/GetAllSubCategory`);
};

// ============================================================
// FILE HELPER
// ============================================================

// Helper function to convert blob URL to File object
const convertBlobUrlToFile = async (fileData) => {
  if (!fileData.FilePath || !fileData.FilePath.startsWith("blob:")) {
    return null;
  }

  try {
    const response = await fetch(fileData.FilePath);
    const blob = await response.blob();

    return new File([blob], fileData.FileName, {
      type: fileData.FileType,
    });
  } catch (error) {
    console.error("Error converting blob to file:", error);
    return null;
  }
};

// ============================================================
// CHATGPT MESSAGE
// ============================================================

export const getMessage = async (
  userDetails,
  prompt,
  currentFileData,
  selected,
  token,
  selectedOption,
) => {
  const Params = {
    CustomerID: userDetails?.CustomerID,
    CategoryID: selectedOption?.categoryId,
    SubCategoryID: selectedOption?.SubCategoryID,
    CustomerMessage: prompt,
    ChatGptPlan: selected?.id === "free" ? 1 : 0,
    TransactionTypeID: 2,
  };

  console.log("object", currentFileData);

  // Create FormData
  const formData = new FormData();

  formData.append("payload", encryptData(Params));

  formData.append("Files", "[]");

  if (currentFileData) {
    const file = await convertBlobUrlToFile(currentFileData);

    if (file) {
      formData.append("ImageFile", file);
    }
  }

  console.log("Params ------- >", Params);

  return api.post(`${URL}/api/ChatGpt/GetChatGptMsg1`, formData, {
    headers: {
      Authorization: `bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

// ============================================================
// LOGIN
// ============================================================

export const loginUser = async (formData) => {
  const Params = {
    PhoneNumber: formData.PhoneNumber,
    OTP: "",
    MPIN: formData.mpin,
    DeviceId: "",
    CustomerID: 0,
    ReferenceCode: "",
    IsMobile: false,
  };

  const payload = {
    payload: encryptData(Params),
  };

  return api.post(`${URL}/api/CustomerMaster/Login`, payload);
};

// ============================================================
// POINTS
// ============================================================

// Get current points data
export const getCurrentPointsData = (userDetails, token) => {
  const Params = {
    TransactionTypeID: 0,
    CustomerID: userDetails?.CustomerID,
  };

  const payload = {
    payload: encryptData(Params),
  };

  return api.post(`${URL}/api/PointPlan/GetOrAddCurrentPointsData`, payload, {
    headers: {
      Authorization: `bearer ${token}`,
    },
  });
};

// Get all point plans
export const getAllPointPlans = () => {
  const payload = {
    payload: encryptData({}),
  };

  return api.post(`${URL}/api/PointPlan/GetAllPointPlan`, payload);
};

// ============================================================
// CASHFREE PAYMENT
// ============================================================

// Initiate CashFree Payment
export const initiateCashFreePayment = (
  selectedId,
  customerId,
  token,
  TotalAmount,
) => {
  const params = {
    PointPlanID: selectedId,
    CustomerID: customerId,
    TotalAmount: TotalAmount,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(
    `${URL}/api/cashFreePayment/CashFreePaymentGateway`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// ============================================================
// CHATGPT HISTORY
// ============================================================

export const ChatGptHistory = (userDetails, token) => {
  const params = {
    CategoryID: 0,
    CustomerID: userDetails?.CustomerID,
    SubCategoryID: 0,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/ChatGpt/GetChatGptHistory`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// CHATGPT PAYMENT DETAILS
// ============================================================

export const ChatGptPaymentDetails = (
  userDetails,
  selectedId,
  orderId,
  token,
) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    PointPlanID: selectedId,
    OderID: orderId,
    TransactionTypeID: 3,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CashFreePayment/AddPaymentDetails`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// POINTS HISTORY
// ============================================================

export const GetPointsHistory = (userDetails, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    TypeId: 4,
    FromDate: null,
    ToDate: null,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/PointPlan/GetPointsHistory`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// PAYMENT HISTORY
// ============================================================

export const GetPaymentHistory = (userDetails, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    FromDate: null,
    ToDate: null,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CashFreePayment/GetPaymentHistoryById`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// GST CALCULATION
// ============================================================

export const GetGstCalculation = (userDetails, selectedId, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    PointPlanID: selectedId,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CashFreePayment/GstCalculation`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// CUSTOMER DETAILS
// ============================================================

export const GetAppicationCustomberDetails = (item, token) => {
  const params = {
    ReferenceCode: item,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(
    `${URL}/api/CustomerMaster/GetCustomerDetilasByCode`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// ============================================================
// WEB CHATGPT PAYMENT
// ============================================================

export const Web_ChatGptPaymentDetails = (params, token) => {
  const payload = {
    payload: encryptData(params),
  };

  return api.post(
    `${URL}/api/CashFreePayment/AddPaymentDetailsForWeb`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// ============================================================
// MANAGER REQUEST
// ============================================================

export const Web_SendManagerRequestJoin = (params, token) => {
  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CustomerMaster/SendManagerRequest`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// PARTNER JOIN
// ============================================================

export const Web_partnerJoin = (params, token) => {
  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/PartnerMaster/Web_partnerCreate`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// ============================================================
// PENSION CALCULATOR
// ============================================================

// Get Bank Pension Data
export const getBankPensionData = (payload) => {
  const params = payload
    ? {
        Age: payload.Age || 0,
        Amount: parseFloat(payload.Amount) || 0,
        AnnuityFrequency: payload.AnnuityFrequency || "",
        AnnuityScheme: payload.AnnuityScheme || "",
        AnnuityValue: payload.AnnuityValue || "",
      }
    : {};

  const encryptedPayload = {
    payload: encryptData(params),
  };

  return api.post(
    `${URL}/api/PensionCalculatorWorkSectorMaster/GetBankPensionData`,
    encryptedPayload,
  );
};

// ============================================================
// EXIT FORM
// ============================================================

// Get Exit Form Data by PRAN Number
export const getExitFormByPran = (pranNumber, customerId) => {
  const params = {
    PranNumber: pranNumber || "",
    CustomerID: customerId || "",
  };

  const encryptedPayload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/ExitForm/GetAllExitFormByPran`, encryptedPayload);
};

// ============================================================
// EXIT FORM PDF
// ============================================================

// Generate Exit Form PDF
export const generateExitFormPDF = (payload) => {
  const encryptedPayload = {
    payload: encryptData(payload),
  };

  return api.post(
    `${URL}/api/ExitForm/AddorUpdateExitForm_Web`,
    encryptedPayload,
  );
};

// Generate Exit Form PDF with FormData
// For file uploads
export const generateExitFormPDFWithFiles = (formData) => {
  return api.post(`${URL}/api/ExitForm/SaveDocument_Web`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Generate Exit Form PDF - Final API call
export const generateExitFormPDFFinal = (id) => {
  const payload = {
    ID: id,
  };

  const encryptedPayload = {
    payload: encryptData(payload),
  };

  return api.post(`${URL}/api/Common/GenerateExitFormPDF`, encryptedPayload);
};

// ============================================================
// S2 FORM
// ============================================================
// Get S2 Form Details by PRAN Number for Web
export const getS2FormByPran = (pranNumber) => {
  const params = {
    PranNumber: pranNumber || "",
  };

  const encryptedPayload = {
    payload: encryptData(params),
  };

  return api.post(
    `${URL}/api/S2FormMaster/GetAllS2FormByPranForWeb`,
    encryptedPayload,
  );
};

// Add or Update S2 Form
export const addOrUpdateS2FormMaster = (payload) => {
  const encryptedPayload = {
    payload: encryptData(payload),
  };

  return api.post(
    `${URL}/api/S2FormMaster/AddorUpdateS2FormMaster`,
    encryptedPayload,
  );
};

// ============================================================
// S2 FORM PDF
// ============================================================

// Generate PDF from S2 Form
export const generateS2FormPDFFinal = (id) => {
  const payload = {
    ID: id,
    IsSkip: false,
  };

  const encryptedPayload = {
    payload: encryptData(payload),
  };

  return api.post(`${URL}/api/Common/GenerateS2FormPDF`, encryptedPayload);
};

// ============================================================
// S2 FORM DOCUMENTS
// ============================================================

export const addOrUpdateS2FormDocuments = (formData) => {
  return api.post(`${URL}/api/S2FormMaster/SaveDocument`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// ============================================================
//  Refresh Token API
// ============================================================

export const refreshTokenById = async (customerId) => {
  const Params = {
    CustomerID: customerId,
  };

  const payload = {
    payload: encryptData(Params),
  };

  return api.post(
    `${URL}/api/CustomerMaster/RefreshByIdForWeb`,
    payload
  );
};
 //This is the new impplemented api for the new exit form
/* ============================================================
   NEW EXIT FORM APIs
============================================================ */

// Save New Exit Form Data
export const newAddOrUpdateExitForm = (payload) => {
  const encryptedPayload = {
    payload: encryptData(payload),
  };

  return api.post(
    `${URL}/api/ExitForm/NewAddorUpdateExitForm_Web`,
    encryptedPayload,
  );
};

// Save New Exit Form Documents
export const newSaveExitFormDocument = (formData) => {
  return api.post(
    `${URL}/api/ExitForm/NewSaveDocument_Web`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

// Generate New Exit Form PDF
export const newGenerateExitFormPDF = (id) => {
  const payload = {
    ID: id,
  };

  const encryptedPayload = {
    payload: encryptData(payload),
  };

  return api.post(
    `${URL}/api/Common/NewGenerateExitFormPDFForWeb`,
    encryptedPayload,
  );
};
